import { render, staticRenderFns } from "./SurplusReturnPartAdd.vue?vue&type=template&id=71252444"
import script from "./SurplusReturnPartAdd.vue?vue&type=script&lang=js"
export * from "./SurplusReturnPartAdd.vue?vue&type=script&lang=js"
import style0 from "./SurplusReturnPartAdd.vue?vue&type=style&index=0&id=71252444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports